import { useState } from "react";
import { useLocation } from "react-router-dom";
import { Info, X } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

/** Hinweis oben auf Orts-/Inselseite, wenn der Gast über die Adresse eines offline geschalteten Objekts kam (Router-State aus PlacePage) */
export const OfflineNotice = ({ name }) => {
  const { state } = useLocation();
  const { t } = useLang();
  const [hidden, setHidden] = useState(false);
  if (!state?.offlineProperty || hidden) return null;
  const scrollToProperties = () => { const el = document.querySelector('[data-testid="landing-properties-title"]'); if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 96, behavior: "smooth" }); };
  return (
    <div className="bg-amber-50 border-b border-amber-200" data-testid="offline-notice">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-amber-900">
        <Info className="w-4 h-4 shrink-0 text-amber-600" />
        <span className="flex-1 min-w-[200px]">{t.offlineNotice.text.replace("{n}", name)}</span>
        <button type="button" onClick={scrollToProperties} className="font-semibold underline underline-offset-2 hover:text-amber-700" data-testid="offline-notice-cta">{t.offlineNotice.cta}</button>
        <button type="button" onClick={() => setHidden(true)} aria-label="Hinweis schließen" className="ml-auto p-1 rounded hover:bg-amber-100" data-testid="offline-notice-close"><X className="w-4 h-4" /></button>
      </div>
    </div>
  );
};
